<template>
  <div class="aqi-info-wrapper h-full pt-8 pb-4">
    <div class="aqi-info-table h-full max-w-xlg mx-auto flex flex-col justify-between" v-if="data" >
      <div class="title text-center text-shadow font-bold mt-4">Air Quality Index</div>
      <LargeFacePills :type="data.index" />
      <div class="last-updated-text self-center mb-4 mx-4 text-shadow-strong">Last updated on {{data.lastUpdated}}</div>
    </div>
  </div>
</template>

<script>
import LargeFacePills from '@/components/generic/LargeFacePills.vue';

export default {
  props: ['data'],
  components: {
    LargeFacePills
  },
  data() {
      return {

      }
  },
  computed: {

  }

}
</script>

<style lang="scss">
.aqi-info-wrapper{
  .header {
    font-size: 1.2rem;
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
  }
  .aqi-info-table {
    border: 2px solid rgba(white, .6);
    border-radius: 20px;
    .title {
      font-size: 3rem;
    }
  }
  .last-updated-text{
    font-size: 1.2rem;
  }
}


 //lg
@media (max-width: 1279.98px) { 
  .aqi-info-wrapper{
    .aqi-info-table {
      .title {
        margin-bottom: 20px;
      }
    }
    .last-updated-text{
      margin-top: 30px;
      font-size: 1.2rem;
    }
  }
}

//md
@media (max-width: 1023.98px) {

}

// sm
@media (max-width: 767.98px) { 
  .aqi-info-wrapper{
    .aqi-info-table {
      .title {
        font-size: 2rem;
      }
    }
    .last-updated-text{
      font-size: 1.2rem;
    }
  }
}

// xs
@media (max-width: 639.98px) { 

}

</style>